import { lazy, Suspense } from 'react'
import { AnimatePresence } from 'framer-motion'
import { Route, Routes, useLocation } from 'react-router-dom'
import Layout from './components/Layout'
import { ArticleSkeleton } from './components/LoadingStates'
import RouteTransition from './components/RouteTransition'
import ScrollToTop from './components/ScrollToTop'

const HomePage = lazy(() => import('./pages/HomePage'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const TeachingsPage = lazy(() => import('./pages/TeachingsPage'))
const TeachingDetailPage = lazy(() => import('./pages/TeachingDetailPage'))
const SongsPage = lazy(() => import('./pages/SongsPage'))
const SongDetailPage = lazy(() => import('./pages/SongDetailPage'))
const BiblePage = lazy(() => import('./pages/BiblePage'))
const NewsPage = lazy(() => import('./pages/NewsPage'))
const NewsDetailPage = lazy(() => import('./pages/NewsDetailPage'))
const ContactPage = lazy(() => import('./pages/ContactPage'))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))

function Page({ children }) {
  return <RouteTransition>{children}</RouteTransition>
}

export default function App() {
  const location = useLocation()
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<section className="section route-loading"><ArticleSkeleton /></section>}>
        <AnimatePresence mode="wait" initial={false}>
          <Routes location={location} key={location.pathname}>
            <Route element={<Layout />}>
              <Route index element={<Page><HomePage /></Page>} />
              <Route path="a-propos" element={<Page><AboutPage /></Page>} />
              <Route path="enseignements" element={<Page><TeachingsPage /></Page>} />
              <Route path="enseignements/:id" element={<Page><TeachingDetailPage /></Page>} />
              <Route path="cantiques" element={<Page><SongsPage /></Page>} />
              <Route path="cantiques/:id" element={<Page><SongDetailPage /></Page>} />
              <Route path="bible" element={<Page><BiblePage /></Page>} />
              <Route path="actualites" element={<Page><NewsPage /></Page>} />
              <Route path="actualites/:id" element={<Page><NewsDetailPage /></Page>} />
              <Route path="contact" element={<Page><ContactPage /></Page>} />
              <Route path="*" element={<Page><NotFoundPage /></Page>} />
            </Route>
          </Routes>
        </AnimatePresence>
      </Suspense>
    </>
  )
}
